import { render, staticRenderFns } from "./WriteInformationModal.vue?vue&type=template&id=53876c82&"
import script from "./WriteInformationModal.vue?vue&type=script&lang=js&"
export * from "./WriteInformationModal.vue?vue&type=script&lang=js&"
import style0 from "./WriteInformationModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports